<template>
  <div class="qualifications-editor">
    <h4><b>{{name}}</b></h4>
    <p class="text-muted">{{description}}</p>
    <b-row>
      <b-col cols="12">
        <b-form-group label="Date">
          <date-picker
            :value="value"
            @input="onDateChange($event)"
            type="month"
            lang="en"
            format="MMM YYYY"
            input-class="mx-input mx-dimensions"
            confirm
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'JobTitleSelector',
  components: {
    Multiselect,
    DatePicker,
  },
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      default: null,
    },
  },
  data: () => ({
    fatalErr: null,
    err: null,
  }),
  methods: {
    onDateChange(date) {
      this.$emit('input', date);
    },
  },
};
</script>

<style lang="scss">
.qualifications-editor {
  .delete-button {
    color: #333;
    cursor: pointer;
    opacity: .75;

    &:hover {
      opacity: 1;
    }
  }
  .mx-datepicker {
    width: 100%;
    .mx-input {

      &.mx-dimensions {
        height: 38px;
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/profile/DateEditor.vue